import { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import lang from '../../../../lib/language';
import { PlanPhaseTypeEnum } from '../../../../lib/models/crm/types';
import { RootState } from '../../../../lib/store';
import { getCurrentAccountTradingPlan } from '../../../../lib/store/crm/helpers';

import LossReachedIcon from '../../../../assets/img/DailyLossReached.png';
import { ResetDailyLossConfirmModal } from '../../../../components';
import ResetDailyLossButton from '../AdditionalInfo/ResetDailyLossButton';

import styles from './LossReachedContainer.module.scss';

const LossReachedContainer = (props: ReduxProps) => {
  const {
    accountStatusData,
    tradingPlan,
  } = props;

  const isChallengePhase = tradingPlan?.phase === PlanPhaseTypeEnum.challenge;
  const [showResetModal, setShowResetModal] = useState<boolean>(false);

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.wrapper}>
        <img className={styles.dailyLossImage} src={LossReachedIcon} alt="Loss reached" />
        <div className={styles.content}>
          <div className={styles.title}>{lang.tradingPlanDailyLossReachedTitle()}</div>
          <div className={styles.text}>{lang.tradingPlanDailyLossReachedPositionsClosed()}</div>
          {isChallengePhase && (
            <>
              <div className={styles.text}>{lang.tradingPlanDailyLossReachedRewindPrompt()}</div>
              <div className={styles.buttonWrapper}>
                <ResetDailyLossButton
                  disabled={accountStatusData.dailyResetProcessing}
                  onClick={() => setShowResetModal(true)}
                />
              </div>
            </>
          )}
        </div>
        <ResetDailyLossConfirmModal
          isOpen={showResetModal}
          isComingFromRewindButtonClick
          isDailyLossReached
          toggleModal={() => setShowResetModal(false)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  accountStatusData: state.closeout.accountStatusData,
  tradingPlan: getCurrentAccountTradingPlan(state.crm),
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(LossReachedContainer);
